import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useForm, useFormContext } from 'react-hook-form';
import { TextField } from '@mui/material';


export default function CompanyInput(props) {
  const [t] = useTranslation();
  const { register, errors, setValue } = useFormContext();
  const { select, onclick } = props;
  useEffect(() => {
    setName(select)
    setValue('companyName', select);
  }, [select]);

  register({ name: 'companyName', value: select });
  // const { register } = useForm();
  // const error = get(errors, name);
  // const validations = validate.reduce((acc, v) => Object.assign(acc, v), {});
  const [name, setName] = useState(select ?? '');
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    // register(event.target.value);
    setName(event.target.value);
  };
  return (
    <TextField
      label="公司" onClick={() => {
        onclick()
      }}
      id="companyName"
      name="companyName"
      value={name}
      onChange={e => {
        register({ name: 'companyName', value: e.target.value });
        handleChange(e);
      }
      }
      required
      fullWidth margin="dense" >

    </TextField>
  );
}


